import { Routes, Route, Navigate } from 'react-router-dom';
import DashboardPage from 'pages/core/DashboardPage/DashboardPage';
import MainPage from 'pages/core/MainPage/MainPage';
import CreateRegistryPage from 'pages/registries/CreateRegistryPage/CreateRegistryPage';
import AllRegistriesPage from 'pages/registries/AllRegistriesPage/AllRegistriesPage';
import MyRegistriesPage from 'pages/registries/MyRegistriesPage/MyRegistriesPage';
import SharedRegistreisPage from 'pages/registries/SharedRegistreisPage/SharedRegistreisPage';
import CaseDetailsPage from 'pages/case/CaseDetailsPage/CaseDetailsPage';
import AddCasePage from 'pages/case/AddCasePage/AddCasePage';
import AllPatientsPage from 'pages/case/AllPatientsPage/AllPatientsPage';
import RVUsCalculatorPage from 'pages/core/RVUsCalculatorPage/RVUsCalculatorPage';
import ContactUs from 'pages/auth/contactUs/ContactUs';
import UsersPage from 'pages/core/UsersPage/UsersPage';
import ProfilePage from 'pages/user/ProfilePage/ProfilePage';
import DoctorMainPage from 'pages/core/DoctorMainPage/DoctorMainPage';
import { useMemo } from 'react';
import { useAuth } from 'context/AuthContext';
import { EPermission } from 'enum/EPermission';

export default function DoctorRoutes() {
  const { doctor } = useAuth();

  const isEditor = useMemo(() => {
    return ((doctor && doctor?.permission != EPermission.VIEWER) || !doctor)
  }, [doctor]);

  return (
    <Routes>
      <Route path="/" element={<DoctorMainPage />}>
        <Route index element={<Navigate to="dashboard" replace />} />

        <Route path="dashboard" element={<DashboardPage />} />

        <Route path="rvus-calculator" element={<RVUsCalculatorPage />} />

        <Route path="patients/all-patients" element={<AllPatientsPage />} />
        <Route path="patients/:patientId" element={<CaseDetailsPage />} />

        {isEditor && <>
          <Route path="patients/add" element={<AddCasePage />} />
          <Route path="patients/:patientId/edit" element={<AddCasePage />} />
        </>}

        <Route path="contact" element={<ContactUs />} />

      </Route>

      {/* fallback for unknown routes */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}
